import { useQuery } from "@tanstack/react-query";

import hubspotEnrichmentAPIService from "../services/api/hubspotEnrichmentAPIService";

import { hubspotEnrichmentQueryKeys } from "./queryKeyFactory";

const useHsEnrichmentSettingsQuery = () => {
    return useQuery({
        queryKey: hubspotEnrichmentQueryKeys.settings(),
        queryFn({ signal }) {
            return hubspotEnrichmentAPIService.getSettings({
                cancellation: signal,
            });
        },
    });
};

export default useHsEnrichmentSettingsQuery;
